<template>
  <va-card>
    <vue-element-loading :active="visible" :is-full-screen="true" />
    <h4 style="font-size: 24px !important" class="text-uppercase">
      Adding Images to Digital Guide
    </h4>
    <br />
    <b-row  class="py-3">
      <b-col cols="12" md="12">
        <span class="poppinsregular" style="font-size: 14px">
          Upload Map Image</span
        >
      </b-col>
      <b-col cols="12" md="6" class="pt-3">
        <output>
          <img
            :src="previewUrl"
            v-if="previewUrl"
            style="width: 150px; height: 150px; object-fit: contain"
          />
        </output>
        <input
          type="file"
          id="file"
          accept="image/*"
          v-on:change="uploadImage($event)"
        />
      </b-col>
      <b-col cols="12" md="6" class="pt-3">
        <div class="formgroup">
             <span class="poppinsregular" style="font-size: 14px">
          Copyright Information</span
        >
          <input
            v-model="mapCopyright"
            type="text"
            required
            class="poppinsregular pa-2 form-control"
            placeholder="Copyright for Map"
            style="
              font-size: 14px;
              color: black !important;
              width: 100% !important;
            "
          />
        </div>
      </b-col>
      <b-col class="pt-2">
        <b-button size="sm" @click="mapImageUpload" variant="success">
          submit
        </b-button>
      </b-col>
    </b-row>
    <hr />
    <div
      id="my-strictly-unique-vue-upload-multiple-image"
      style="display: flex; justify-content: center"
    >
      <vue-upload-multiple-image
        @upload-success="uploadImageSuccess"
        @limit-exceeded="imageLimit"
        :data-images="images"
        drag-text="Drag pictures"
        browse-text="Browse picture(s)"
        mark-is-primary-text="Set as default"
        popup-text="This image will be displayed as default"
        :show-edit="false"
        :show-delete="false"
        :maxImage="4"
      ></vue-upload-multiple-image>
    </div>

    <br />
    <p align="center">
      <b-button
        type="Submit"
        v-on:click="aler"
        pill
        variant="btn btn-secondary rad1"
        style="padding-left: 30px; padding-right: 30px !important"
      >
        <b>NEXT</b>
      </b-button>
      <br />
      <b-modal
        size="md"
        id="modal-uploadImageCopyright"
        centered
        :hide-backdrop="false"
        hide-footer
        hide-header
      >
        <form @submit="onSubmit">
          <!-- <p class="poppinsbold" style="font-size: 18px">
            NOTIFY THE TEAM MEMBER
          </p> -->
          <div class="pb-3">
            <label style="font-size: 14px" class="poppinsregular">
              Please Enter Copyright message
              <sup>*</sup>
            </label>
            <div class="formgroup">
              <input
                v-model="copyright"
                type="text"
                required
                class="poppinsregular pa-2 form-control"
                placeholder="Copyright Message"
                style="
                  font-size: 14px;
                  color: black !important;
                  width: 100% !important;
                "
              />
            </div>
          </div>

          <b-button variant="success" size="sm" class="px-2" type="submit"
            >SUBMIT</b-button
          >
        </form>
      </b-modal>
    </p>
  </va-card>
</template>
<script>
import axios from "axios";
import VueElementLoading from "vue-element-loading";
import VueUploadMultipleImage from "vue-upload-multiple-image";
export default {
  props: ["id"],
  components: {
    VueElementLoading,
    VueUploadMultipleImage,
  },
  data() {
    return {
      visible: false,
      img: 0,
      count: 0,
      images: [],
      photos: [],
      msg: "",
      previewUrl: "",
      selectedFile: null,
      url: null,
      key: null,
      copyright: null,
      mapImage: null,
      mapCopyright: null,
    };
  },
  methods: {
    uploadImage(event) {
      this.mapImage = event.target.files[0];
      // this.url = URL.createObjectURL(this.mapImage);
      const file = event.target.files[0];
      if (file) {
        this.stat = 1;
      } else {
        this.stat = 0;
        return false;
      }
      if (!file.type.match("image.*")) {
        // return false
        this.stat = 0;
      } else {
        this.stat = 1;
      }
      const reader = new FileReader();
      const that = this;
      reader.onload = function (e) {
        that.previewUrl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    aler() {
      this.msg = "Record Details added successfully";
      this.$dlg.alert(
        this.msg,
        () => {
          this.$router.push({ name: "listRecords" });
        },
        { messageType: "success" }
      );
    },
    onSelectImage(event) {
      console.log(event.id);
      this.deleteId = event.id;
    },
    imguplderr(resp) {
      console.log(resp);
    },
    imageLimit() {
      this.msg = "Upload Limit exceeded Please Select max 4 images";
      this.$dlg.alert(
        this.msg,
        () => {
          // this.$router.push("/Dashboard");
        },
        { messageType: "error" }
      );
    },
    uploadImageSuccess(formData, index, fileList) {
      console.log("data", formData, index, fileList);
      formData.append("id", this.id);
      this.visible = true;

      axios({
        method: "POST",
        url: "/digitalguide/upload/photo/" + this.id,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status === true) {
            this.msg = " image upload success";
            this.$bvToast.toast(this.msg, {
              title: `New Message`,
              variant: "success",
              solid: true,
            });

            this.visible = false;
          } else {
            this.msg = " Something Went Wrong";
            this.$bvToast.toast(this.msg, {
              title: `New Message`,
              variant: "danger",
              solid: true,
            });

            this.visible = false;
          }
        })
        .catch((e) => {
          this.msg = "Image Upload Not Success";
          this.$dlg.alert(
            this.msg,
            () => {
              this.$router.push({ name: "listRecords" });
            },
            { messageType: "error" }
          );
        });
    },
    onSubmit(evt) {
      this.visible = true;
      evt.preventDefault();
      var data1 = {};
      data1["id"] = this.id;
      data1["copyright"] = this.copyright;
      data1["key"] = this.key;
      axios({
        method: "POST",
        url: "/digitalguide/photos/copyright/add",
        data: data1,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.visible = false;
          if (response.data.status === true) {
            // this.$router.push({ name: "myprofile" });
            this.$bvModal.hide("modal-uploadImageCopyright");
            this.photoView();
          } else {
            this.$dlg.alert(
              this.msg,
              () => {
                window.location.reload();
              },
              { messageType: "error" }
            );
          }
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data.status === false) {
            this.msg = "Please Try Again";
          }
        });
    },

    mapImageUpload() {
      if (this.mapImage) {
        let formData = new FormData();
        formData.append("mapImage", this.mapImage
        );
        formData.append("copyright", this.mapCopyright);

        formData.append("id", this.id);
        this.visible = true;
        axios({
          method: "post",
          url: "/digitalguide/upload/mapImage",
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
            token: localStorage.getItem("token"),
          },
        })
          .then((response) => {
            if (response.data.status === true) {
              this.visible = false;

              this.$bvToast.toast(response.data.msg, {
                title: `New Message`,
                variant: "success",
                solid: true,
              });
            } else {
              this.visible = false;

              this.$bvToast.toast(response.data.msg, {
                title: `New Message`,
                variant: "danger",
                solid: true,
              });
            }
          })

          .catch((e) => {
            this.visible = false;
          });
      } else {
        this.$bvToast.toast("please upload map image", {
          title: `New Message`,
          variant: "danger",
          solid: true,
        });
      }
    },
  },
};
</script>
<style scoped>
#my-strictly-unique-vue-upload-multiple-image {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.card {
  box-shadow: 0px 0px 0px 0px #707070 !important;
}
</style>
